export default {
  cognito: {
    REGION: 'us-east-2',
    USER_POOL_ID: 'us-east-2_VOQrWohIZ',
    APP_CLIENT_ID: 'f444ormea01khdbtedieqergo',
    IDENTITY_POOL_ID:'us-east-2:9f038e14-2cb8-441d-b89a-8a3ed4aa8b7e'
  }
};